import { FlowCardLoading } from '@components/FlowCard'
import { SignUpVerifyPin } from '@components/RouteComponents'
import { orgDetailsQueryOptions } from '@src/queryOptions/org'
import { userTermsQueryOptions } from '@src/queryOptions/terms'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_initialized/phone/signUpVerifyPin')({
  loader: async ({ context: { queryClient, store } }) => {
    const storeState = store.getState().onboarding
    return Promise.all([
      queryClient.ensureQueryData(userTermsQueryOptions),
      queryClient.ensureQueryData(
        orgDetailsQueryOptions({ organizationId: storeState.orgId })
      ),
    ])
  },
  pendingComponent: FlowCardLoading,
  component: SignUpVerifyPin,
})
